export const largeScreenNotificationsFeature =
    '_hm-36-large-screen-notifications';

export const mojoNotificationFlag = '_hm_139_mojo_notification_enabled';
